import { render } from "./AlertBox.vue?vue&type=template&id=49108d77&ts=true"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"

import "./AlertBox.vue?vue&type=style&index=0&id=49108d77&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__